<script setup>
import Menu from "primevue/menu"
import {useIsMobile} from "~/composables/useIsMobile";

const config = useRuntimeConfig()

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  }
})

const isMobile = useIsMobile()
const menuRef = ref(null)
const selectedMenuItems = ref([])

async function openMenuItem(event, item) {
  if (!item.items) return

  selectedMenuItems.value = item.items
  menuRef.value?.toggle(event)
}

function hasBadge(item) {
  return !isNaN(item?.badge) && item.badge > 0
}

function mustShowItemIcon(item) {
  return ['icon', 'icon_text'].includes(item.type) && item.icon
}

function getItemLink(item) {
  return item.url || '#'
}

function getItemLinkTarget(item) {
  return (item.url.startsWith('http') && !item.url.includes(config.public.hostname)) ? '_blank' : null
}

function hasItemLink(item) {
  return !!item?.url
}

function hasItemCommand(item) {
  return !hasItemLink(item) && item.command && typeof item.command === 'function'
}

function onElementClick() {
  menuRef.value?.hide()
}

function executeCommand(item) {
  if (typeof item.command !== 'function') return

  item.command()
}

watch(() => isMobile.value, (newValue, oldValue) => {
  if (!newValue && oldValue) {
    menuRef.value?.hide()
  }
})
</script>

<template>
  <div>
    <template v-for="(item, index) in props.items">
      <!-- MENÚ PADRE -->
      <a v-if="item.items && item.items.length > 0" :key="index"
         class="flex justify-start item-center"
         href="#" @click.prevent="(event) => openMenuItem(event, item)">
        <i v-if="mustShowItemIcon(item)" class="flex items-center mr-2" :class="item.icon"/>
        <span class="hover:underline text-[#363330]">{{ item.label }}</span>
        <i class="ml-1 text-black flex items-center pi pi-chevron-down"/>
      </a>
      <template v-else>
        <NuxtLink
          v-if="hasItemLink(item)"
          class="relative flex justify-start item-center"
          :to="getItemLink(item)"
          :external="getItemLinkTarget(item)"
        >
          <Transition>
            <Badge v-show="hasBadge(item)" class="absolute right-[-13px] top-[-10px]" :value="item.badge"
                   severity="danger" size="small"/>
          </Transition>
          <i v-if="mustShowItemIcon(item)" class="flex items-center mr-2 text-teal-600" :class="item.icon"/>
          <span class="hover:underline text-black">{{ item.label }}</span>
        </NuxtLink>
        <a
          v-if="hasItemCommand(item)"
          class="relative flex justify-start item-center"
          href="#"
          @click.prevent="executeCommand(item)"
        >
          <Transition>
            <Badge v-show="hasBadge(item)" class="absolute right-[-13px] top-[-10px]" :value="item.badge"
                   severity="danger" size="small"/>
          </Transition>
          <i v-if="mustShowItemIcon(item)" class="flex items-center mr-2 text-teal-600" :class="item.icon"/>
          <span class="hover:underline text-black">{{ item.label }}</span>
        </a>
      </template>
    </template>
    <Menu ref="menuRef" id="overlay_menu" :model="selectedMenuItems" class="p-1 !bg-white" :popup="true"
          @click="onElementClick">
      <template #submenulabel="{ item }">
        <NuxtLink
          class="flex items-center !p-0 hover:!bg-white"
          :to="getItemLink(item)"
          :target="getItemLinkTarget(item)"
        >
          <span v-if="mustShowItemIcon(item)" :class="item.icon" class="mr-2"/>
          <span class="text-black italic text-sm hover:!underline">{{ item.label }}</span>
        </NuxtLink>
      </template>
    </Menu>
  </div>
</template>

